import { useMemo } from 'react';
import { useGetPluginInstances } from '@/shared/services/instances/hooks/use-get-plugin-instances';
import { useNeedetGetPlugins } from './use-get-needed-plugins';
// Опции выпадающих списков плагинов и агентов - общие для форм добавления и редактирования системы.
export const useSystemFormOptions = () => {
    const { data: pluginInstances } = useGetPluginInstances();
    const { data: pluginsList } = useNeedetGetPlugins();
    return useMemo(() => {
        const getPluginOptions = (pluginType) => pluginsList?.huHeadPluginDescriptions
            ?.filter(({ pluginTypeDescription }) => pluginTypeDescription === pluginType)
            .map(({ name, guid }) => ({
            label: name,
            value: guid,
        })) || [];
        return {
            serializationOptions: getPluginOptions('Serialization'),
            integrationOptions: getPluginOptions('Integration'),
            objectServeOptions: getPluginOptions('ObjectServing'),
            asyncIntegrationOptions: getPluginOptions('IntegrationAsyncDataProvider'),
            pluginInstanceOptions: pluginInstances?.pluginInstanceInfoWithHeadAddresses.map(({ name, guid }) => ({
                label: name,
                value: guid,
            })) || [],
        };
    }, [pluginsList, pluginInstances]);
};
